import { createContext, useContext } from "react";
import type { RosterChangeCell } from "@/services/roster/changeNotices";
const emptyCells = new Map<string, RosterChangeCell>();
export const VersionChangesContext =
  createContext<ReadonlyMap<string, RosterChangeCell>>(emptyCells);
export function useVersionChangeCell(nurseId: string, day: number) {
  return useContext(VersionChangesContext).get(`${nurseId}:${day}`);
}

export function useVersionChangeRow(nurseId: string) {
  const cells = useContext(VersionChangesContext);
  return [...cells.values()].filter((cell) => cell.nurse_id === nurseId);
}
